import { useEffect } from "react";

//#region src/useTheme.ts
const useTheme = ({ theme }) => {
	useEffect(() => {
		if (!theme) return;
		const previousTheme = document.documentElement.dataset.theme;
		if (theme === previousTheme) return;
		document.documentElement.dataset.theme = theme;
		return () => {
			if (previousTheme === void 0) delete document.documentElement.dataset.theme;
			else document.documentElement.dataset.theme = previousTheme;
		};
	}, [theme]);
};

//#endregion
export { useTheme };
//# sourceMappingURL=useTheme.js.map